(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tm-flexible-vehicle-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const KEYS=['mk','md','br','ka'];
  const LABELS=['Marke','Modell','Baureihe','Karosserie'];
  const slug=(value)=>String(value||'').trim().toLowerCase().replace(/ß/g,'ss').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  const MODEL_ORDER={"Audi":["A1","S1","A3","S3","RS3","A4","S4","A4 allroad","A5","S5","RS5","A6","S6","RS6","A6 allroad","A7","S7","RS7","A8","e-tron","e-tron GT","Q2","SQ2","Q3","RS Q3","Q5","Q7","SQ7","Q8","SQ8","RS Q8","R8","TT","TTS"],"BMW":["1er","M135","2er","M235","M240i","M2","3er","M340i","M3","4er","M440i","M4","5er","M5","6er","7er","8er","M8","i3","i5","iX","iX2","iX3","X1","X2","X3","X3 M","X4","X4 M","X5","X5 M","X6","X6 M","X7","XM","Z4"],"Mercedes-Benz":["A-Klasse","A 35 AMG","A 45 AMG","AMG GT","B-Klasse","C-Klasse","C 43 AMG","C 63 AMG","C 63 S AMG","CLA","CLA 35 AMG","CLA 45 AMG","CLE","CLS","E-Klasse","E 63 AMG","EQA","EQE","G-Klasse","G 63 AMG","GLA","GLA 45 AMG","GLB","GLC","GLE","GLE 63 AMG","GLS","GLS 63 AMG","S-Klasse","SL","SL 43 AMG","SL 55 AMG","SL 63 AMG","SLC","SLC 43 AMG","SLK"]};
  const sortValues=(values,index,brand)=>{
    return values.sort((a,b)=>{
      if(index===5)return Number(b)-Number(a);
      if(index===1&&brand){
        const order=MODEL_ORDER[brand]||[];
        const ai=order.indexOf(a),bi=order.indexOf(b);
        const ar=ai<0?999:ai,br=bi<0?999:bi;
        if(ar!==br)return ar-br;
      }
      return String(a).localeCompare(String(b),'de',{numeric:true,sensitivity:'base'});
    });
  };
  const mobile=()=>window.matchMedia('(max-width: 749px)').matches;

  document.querySelectorAll('[data-tm-vfp]').forEach((root)=>{
    if(root.dataset.ready==='true')return;
    root.dataset.ready='true';

    let rows=[];
    try{rows=JSON.parse(root.querySelector('.tm-vfp__data')?.textContent||'[]')}catch(error){return}

    const fields=Array.from(root.querySelectorAll('[data-vfp-field]')).map((field,index)=>({
      field,index,
      trigger:field.querySelector('[data-vfp-trigger]'),
      value:field.querySelector('[data-vfp-value]'),
      menu:field.querySelector('[data-vfp-menu]'),
      options:field.querySelector('[data-vfp-options]'),
      searchWrap:field.querySelector('[data-vfp-search-wrap]'),
      search:field.querySelector('[data-vfp-search]'),
      close:field.querySelector('[data-vfp-close]')
    }));
    const submit=root.querySelector('[data-vfp-submit]');
    const backdrop=root.querySelector('[data-vfp-backdrop]');
    const placeholders=fields.map((item)=>item.value.textContent.trim());
    const state=new Array(fields.length).fill('');
    let openIndex=-1;

    const validRows=(index)=>rows.filter((row)=>{
      for(let i=0;i<index;i+=1){
        if(state[i] && row[i]!==state[i])return false;
      }
      return true;
    });

    const valuesFor=(index)=>sortValues([...new Set(validRows(index).map((row)=>row[index]).filter(Boolean))],index,state[0]);

    const setBodyLock=(locked)=>{
      if(!mobile())return;
      document.documentElement.style.overflow=locked?'hidden':'';
      document.body.style.overflow=locked?'hidden':'';
    };

    const closeMenu=(returnFocus=true)=>{
      if(openIndex<0)return;
      const current=fields[openIndex];
      current.field.classList.remove('is-open');
      current.trigger.setAttribute('aria-expanded','false');
      root.classList.remove('is-sheet-open');
      setBodyLock(false);
      current.search.value='';
      openIndex=-1;
      if(returnFocus)current.trigger.focus({preventScroll:true});
    };

    const filterOptions=(item,query)=>{
      const q=String(query||'').trim().toLocaleLowerCase('de');
      let visible=0;
      item.options.querySelectorAll('.tm-vfp__option').forEach((button)=>{
        const show=!q||button.dataset.search.includes(q);
        button.hidden=!show;
        if(show)visible+=1;
      });
      const existing=item.options.querySelector('.tm-vfp__empty');
      if(existing)existing.remove();
      if(!visible){
        const empty=document.createElement('div');
        empty.className='tm-vfp__empty';
        empty.textContent='Keine passende Auswahl gefunden';
        item.options.appendChild(empty);
      }
    };

    const renderOptions=(item)=>{
      const values=valuesFor(item.index);
      item.options.innerHTML='';
      item.searchWrap.hidden=values.length<8;

      values.forEach((optionValue)=>{
        const button=document.createElement('button');
        button.type='button';
        button.className='tm-vfp__option'+(state[item.index]===optionValue?' is-selected':'');
        button.setAttribute('role','option');
        button.setAttribute('aria-selected',state[item.index]===optionValue?'true':'false');
        button.dataset.value=optionValue;
        button.dataset.search=optionValue.toLocaleLowerCase('de');
        button.innerHTML=`<span></span><span class="tm-vfp__option-mark"><svg viewBox="0 0 20 20"><path d="m5.5 10.5 3 3 6-7"/></svg></span>`;
        button.firstElementChild.textContent=optionValue;
        button.addEventListener('click',()=>{
          state[item.index]=optionValue;
          for(let i=item.index+1;i<state.length;i+=1)state[i]='';
          refresh();
          closeMenu(false);
          const next=fields[item.index+1];
          if(next&&!next.trigger.disabled&&!mobile())window.setTimeout(()=>next.trigger.focus({preventScroll:true}),60);
        });
        item.options.appendChild(button);
      });
      return values;
    };

    const openMenu=(index)=>{
      const item=fields[index];
      if(item.trigger.disabled)return;
      if(openIndex===index){closeMenu();return}
      if(openIndex>=0)closeMenu(false);
      renderOptions(item);
      openIndex=index;
      item.field.classList.add('is-open');
      item.trigger.setAttribute('aria-expanded','true');
      if(mobile())root.classList.add('is-sheet-open');
      setBodyLock(true);
      if(!item.searchWrap.hidden){
        window.setTimeout(()=>item.search.focus({preventScroll:true}),mobile()?180:80);
      }
    };

    const refresh=()=>{
      let previousReady=true;
      fields.forEach((item,index)=>{
        const values=previousReady?valuesFor(index):[];
        if(state[index]&&!values.includes(state[index])){
          state[index]='';
          for(let j=index+1;j<state.length;j+=1)state[j]='';
        }
        const enabled=index===0||Boolean(state[index-1]);
        item.trigger.disabled=!enabled;
        item.value.textContent=state[index]||placeholders[index];
        item.field.classList.toggle('has-value',Boolean(state[index]));
        previousReady=enabled&&Boolean(state[index]);
      });
      submit.disabled=!state[0];
    };

    fields.forEach((item)=>{
      item.trigger.addEventListener('click',()=>openMenu(item.index));
      item.close.addEventListener('click',()=>closeMenu());
      item.search.addEventListener('input',()=>filterOptions(item,item.search.value));
      item.search.addEventListener('keydown',(event)=>{
        if(event.key==='Escape'){event.preventDefault();closeMenu()}
        if(event.key==='ArrowDown'){
          const first=Array.from(item.options.querySelectorAll('.tm-vfp__option:not([hidden])'))[0];
          if(first){event.preventDefault();first.focus()}
        }
      });
      item.options.addEventListener('keydown',(event)=>{
        const buttons=Array.from(item.options.querySelectorAll('.tm-vfp__option:not([hidden])'));
        const pos=buttons.indexOf(document.activeElement);
        if(event.key==='Escape'){event.preventDefault();closeMenu()}
        if(event.key==='ArrowDown'&&pos>-1){event.preventDefault();(buttons[pos+1]||buttons[0])?.focus()}
        if(event.key==='ArrowUp'&&pos>-1){event.preventDefault();(buttons[pos-1]||buttons[buttons.length-1])?.focus()}
      });
    });

    backdrop.addEventListener('click',()=>closeMenu());

    document.addEventListener('pointerdown',(event)=>{
      if(openIndex<0||mobile())return;
      if(!fields[openIndex].field.contains(event.target))closeMenu(false);
    });

    document.addEventListener('keydown',(event)=>{
      if(event.key==='Escape'&&openIndex>=0){event.preventDefault();closeMenu()}
    });

    submit.addEventListener('click',()=>{
      const chosen=[];
      for(const value of state){if(!value)break;chosen.push(value)}
      if(!chosen.length)return;
      let tag='tmfit';
      chosen.forEach((value,index)=>{tag+=`-${KEYS[index]}-${slug(value)}`});
      const vehicleLabel=chosen.filter((value)=>value!=='Serie / Standard').join(' ');
      window.location.assign(`/collections/all/${tag}?vehicle=${encodeURIComponent(vehicleLabel)}`);
    });

    window.addEventListener('resize',()=>{
      if(openIndex>=0&&!mobile())root.classList.remove('is-sheet-open');
      if(openIndex<0)setBodyLock(false);
    },{passive:true});

    refresh();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-home-brand-categories"] && !Shopify.designMode) return;
  try {
    
const tmHomeInit = (section) => {
  if (!section || section.dataset.tmHomeReady === 'true') return;

  section.dataset.tmHomeReady = 'true';

  section.querySelectorAll('[data-tm-home-rail]').forEach((rail) => {
    const target = rail.dataset.tmHomeRail;
    const controls = section.querySelectorAll('[data-tm-home-target="' + target + '"]');

    const updateControls = () => {
      const maxScroll = rail.scrollWidth - rail.clientWidth;

      controls.forEach((control) => {
        const direction = Number(control.dataset.tmHomeDirection);
        const atStart = rail.scrollLeft <= 1;
        const atEnd = rail.scrollLeft >= maxScroll - 1;

        control.disabled = maxScroll <= 1 || (direction < 0 ? atStart : atEnd);
      });
    };

    controls.forEach((control) => {
      control.addEventListener('click', () => {
        rail.scrollBy({
          left: rail.clientWidth * 0.78 * Number(control.dataset.tmHomeDirection),
          behavior: 'smooth'
        });
      });
    });

    rail.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  });
};

const tmHomeInitAll = () => {
  document.querySelectorAll('[data-tm-home]').forEach(tmHomeInit);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tmHomeInitAll);
} else {
  tmHomeInitAll();
}

document.addEventListener('shopify:section:load', (event) => {
  tmHomeInit(event.target.querySelector('[data-tm-home]') || event.target);
});

  } catch(e) { console.error(e); }
})();
})();
